var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "unitModal",
          staticClass: "unit-modal-wrapper",
          attrs: {
            size: "lg",
            "hide-header": "",
            "hide-footer": "",
            "header-class": "unit-modal-header",
            "body-class": "p-0",
          },
          on: { hidden: _vm.clearData },
        },
        [
          _c("div", { staticClass: "unit-container d-flex" }, [
            _c(
              "div",
              {
                staticClass:
                  "unit-header w-100 px-4 pt-2 pb-2 d-flex d-md-none justify-content-between align-items-center",
              },
              [
                _c("h5", { staticClass: "mb-0 unit-name" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.record.unit_name || "New Unit") +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "unit-actions d-flex" }, [
                  !_vm.isEditing && !_vm.isNewRecord
                    ? _c(
                        "span",
                        {
                          staticClass: "modal-btn action-btn",
                          on: { click: _vm.deleteRecord },
                        },
                        [
                          _c("i", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                value: "Delete Unit",
                                expression: "'Delete Unit'",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass: "delete-unit fi-trash nav-icon",
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "modal-btn action-btn",
                      on: { click: _vm.toggleEditMode },
                    },
                    [
                      _vm.isEditing
                        ? _c("i", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                value: "Save Unit",
                                expression: "'Save Unit'",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass: "save-unit fi-save nav-icon",
                          })
                        : _c("i", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                value: "Edit Unit",
                                expression: "'Edit Unit'",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass: "edit-unit fi-pencil nav-icon",
                          }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "modal-btn action-btn",
                      on: { click: _vm.hide },
                    },
                    [
                      _c("i", {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover.top",
                            value: "Close Window",
                            expression: "'Close Window'",
                            modifiers: { hover: true, top: true },
                          },
                        ],
                        staticClass: "cancel-contact fi-x nav-icon",
                      }),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "unit-sidenav d-none d-md-flex" }, [
              _c("div", { staticClass: "sidenav-header mb-4" }, [
                _c("div", { staticClass: "nav-section-title text-center" }, [
                  _c("div", { staticClass: "unit-avatar mx-auto mb-2" }, [
                    _vm.record.unit_image
                      ? _c("img", {
                          staticClass: "avatar-img",
                          attrs: {
                            src: _vm.record.unit_image,
                            alt: "Unit photo",
                          },
                        })
                      : _c(
                          "div",
                          {
                            staticClass:
                              "avatar-placeholder d-flex align-items-center justify-content-center",
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.getInitials) +
                                "\n              "
                            ),
                          ]
                        ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "unit-nav-items" },
                _vm._l(_vm.sections, function (section, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "unit-nav-item",
                      class: { active: _vm.activeSection === section.id },
                      on: {
                        click: function ($event) {
                          return _vm.scrollToSection(section.id)
                        },
                      },
                    },
                    [
                      _c("i", { class: section.icon }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-2" }, [
                        _vm._v(_vm._s(section.title)),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("input", {
                ref: "fileInput",
                staticStyle: { display: "none" },
                attrs: { type: "file" },
                on: { change: _vm.onFileChanged },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "unitContent",
                staticClass: "unit-content",
                on: { scroll: _vm.handleScroll },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "desktop-header px-4 pt-2 pb-2 d-none d-md-flex justify-content-between align-items-center",
                  },
                  [
                    _c("h5", { staticClass: "mb-0 unit-name" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.record.unit_name || "New Unit") +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "unit-actions d-flex" }, [
                      !_vm.isEditing && !_vm.isNewRecord
                        ? _c(
                            "span",
                            {
                              staticClass: "modal-btn action-btn",
                              on: { click: _vm.deleteRecord },
                            },
                            [
                              _c("i", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.top",
                                    value: "Delete Unit",
                                    expression: "'Delete Unit'",
                                    modifiers: { hover: true, top: true },
                                  },
                                ],
                                staticClass: "delete-unit fi-trash nav-icon",
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "modal-btn action-btn",
                          on: { click: _vm.toggleEditMode },
                        },
                        [
                          _vm.isEditing
                            ? _c("i", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.top",
                                    value: "Save Unit",
                                    expression: "'Save Unit'",
                                    modifiers: { hover: true, top: true },
                                  },
                                ],
                                staticClass: "save-unit fi-save nav-icon",
                              })
                            : _c("i", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.top",
                                    value: "Edit Unit",
                                    expression: "'Edit Unit'",
                                    modifiers: { hover: true, top: true },
                                  },
                                ],
                                staticClass: "edit-unit fi-pencil nav-icon",
                              }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "modal-btn action-btn",
                          on: { click: _vm.hide },
                        },
                        [
                          _c("i", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                value: "Close Window",
                                expression: "'Close Window'",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass: "cancel-contact fi-x nav-icon",
                          }),
                        ]
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "unit-body px-4" },
                  [
                    _c(
                      "b-card",
                      {
                        ref: "details",
                        staticClass: "mb-3 section-card",
                        attrs: { "no-body": "", id: "details" },
                      },
                      [
                        _c(
                          "b-card-header",
                          {
                            staticClass: "p-2 border-bottom-0 text-left",
                            attrs: { "header-tag": "header", role: "tab" },
                          },
                          [
                            _c("i", { staticClass: "fi-home mr-2" }),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("unit_modal.details_title") ||
                                    "Details"
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-card-body",
                          [
                            !_vm.isEditing
                              ? _c("div", { staticClass: "readonly-display" }, [
                                  _c("div", { staticClass: "readonly-row" }, [
                                    _c(
                                      "label",
                                      { staticClass: "readonly-label" },
                                      [_vm._v(_vm._s(_vm.$t("unit_name")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "readonly-value" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.record.unit_name || "Not set"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "readonly-row" }, [
                                    _c(
                                      "label",
                                      { staticClass: "readonly-label" },
                                      [_vm._v(_vm._s(_vm.$t("unit_rate")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "readonly-value" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.record.unit_rate || "Not set"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "readonly-row" }, [
                                    _c(
                                      "label",
                                      { staticClass: "readonly-label" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("unit_description"))
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "readonly-value" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.record.unit_description ||
                                              "Not set"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "readonly-row" }, [
                                    _c(
                                      "label",
                                      { staticClass: "readonly-label" },
                                      [_vm._v(_vm._s(_vm.$t("occ_adults")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "readonly-value" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.record.occ_adults || "Not set"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "readonly-row" }, [
                                    _c(
                                      "label",
                                      { staticClass: "readonly-label" },
                                      [_vm._v(_vm._s(_vm.$t("occ_children")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "readonly-value" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.record.occ_children || "Not set"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "readonly-row" }, [
                                    _c(
                                      "label",
                                      { staticClass: "readonly-label" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("default_occupancy"))
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "readonly-value" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.record.default_occupancy ||
                                              "Not set"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.virtualKey.usesVirtualKey
                                    ? _c(
                                        "div",
                                        { staticClass: "readonly-row" },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "readonly-label" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("virtual key name")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "readonly-value" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.record
                                                    .virtual_key_unit_name ||
                                                    "Not set"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _c(
                                  "b-form",
                                  [
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { sm: "12", md: "6" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: _vm.$t("unit_name"),
                                                  "label-for": "UnitNameInput",
                                                },
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "UnitNameInput",
                                                    type: "text",
                                                    state: _vm.unitNameValid,
                                                    placeholder:
                                                      _vm.$t("unit_name"),
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.$v.record.unit_name
                                                        .$touch,
                                                  },
                                                  model: {
                                                    value: _vm.record.unit_name,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.record,
                                                        "unit_name",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "record.unit_name",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          { attrs: { sm: "12", md: "6" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: _vm.$t("unit_rate"),
                                                  "label-for": "UnitRateInput",
                                                },
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "UnitRateInput",
                                                    type: "number",
                                                    state: _vm.unitRateValid,
                                                    placeholder:
                                                      _vm.$t("unit_rate"),
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.$v.record.unit_rate
                                                        .$touch,
                                                  },
                                                  model: {
                                                    value: _vm.record.unit_rate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.record,
                                                        "unit_rate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "record.unit_rate",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          { attrs: { sm: "12", md: "12" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label:
                                                    _vm.$t("unit_description"),
                                                  "label-for":
                                                    "UnitDescriptionInput",
                                                },
                                              },
                                              [
                                                _c("b-form-textarea", {
                                                  attrs: {
                                                    id: "UnitDescriptionInput",
                                                    state:
                                                      _vm.unitDescriptionValid,
                                                    placeholder:
                                                      _vm.$t(
                                                        "unit_description"
                                                      ),
                                                    rows: "3",
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.$v.record
                                                        .unit_description
                                                        .$touch,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.record
                                                        .unit_description,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.record,
                                                        "unit_description",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "record.unit_description",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          { attrs: { sm: "12", md: "4" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: _vm.$t("occ_adults"),
                                                  "label-for": "OccAdultsInput",
                                                },
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "OccAdultsInput",
                                                    type: "number",
                                                    state: _vm.occAdultsValid,
                                                    placeholder:
                                                      _vm.$t("occ_adults"),
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.$v.record.occ_adults
                                                        .$touch,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.record.occ_adults,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.record,
                                                        "occ_adults",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "record.occ_adults",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          { attrs: { sm: "12", md: "4" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: _vm.$t("occ_children"),
                                                  "label-for":
                                                    "OccChildrenInput",
                                                },
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "OccChildrenInput",
                                                    type: "number",
                                                    placeholder:
                                                      _vm.$t("occ_children"),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.record.occ_children,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.record,
                                                        "occ_children",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "record.occ_children",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          { attrs: { sm: "12", md: "4" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label:
                                                    _vm.$t("default_occupancy"),
                                                  "label-for":
                                                    "DefaultOccupancyInput",
                                                },
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "DefaultOccupancyInput",
                                                    type: "number",
                                                    state:
                                                      _vm.defaultOccupancyValid,
                                                    placeholder:
                                                      _vm.$t(
                                                        "default_occupancy"
                                                      ),
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.$v.record
                                                        .default_occupancy
                                                        .$touch,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.record
                                                        .default_occupancy,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.record,
                                                        "default_occupancy",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "record.default_occupancy",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.virtualKey.usesVirtualKey
                                          ? _c(
                                              "b-col",
                                              { attrs: { sm: "12", md: "6" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      label:
                                                        _vm.$t(
                                                          "virtual key name"
                                                        ),
                                                      "label-for":
                                                        "VirtualKeyInput",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-center",
                                                      },
                                                      [
                                                        _vm.virtualKey
                                                          .isEditingVK
                                                          ? _c("b-form-input", {
                                                              staticClass:
                                                                "mr-2",
                                                              attrs: {
                                                                id: "VirtualKeyInput",
                                                                type: "text",
                                                                placeholder:
                                                                  _vm.$t(
                                                                    "virtual key unit name"
                                                                  ),
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.record
                                                                    .virtual_key_unit_name,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.record,
                                                                      "virtual_key_unit_name",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "record.virtual_key_unit_name",
                                                              },
                                                            })
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mr-2",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.record
                                                                        .virtual_key_unit_name ||
                                                                        "Not set"
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                              ]
                                                            ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-button",
                                                          {
                                                            attrs: {
                                                              size: "sm",
                                                              variant:
                                                                "outline-primary",
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.editVKName,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  !_vm
                                                                    .virtualKey
                                                                    .isEditingVK
                                                                    ? "Setup"
                                                                    : "Link"
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.virtualKey.didError
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-danger mt-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.virtualKey
                                                                    .error
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      {
                        ref: "photos",
                        staticClass: "mb-3 section-card",
                        attrs: { "no-body": "", id: "photos" },
                      },
                      [
                        _c(
                          "b-card-header",
                          {
                            staticClass: "p-2 border-bottom-0 text-left",
                            attrs: { "header-tag": "header", role: "tab" },
                          },
                          [
                            _c("i", { staticClass: "fi-camera mr-2" }),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("unit_modal.photos_title") || "Photos"
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("b-card-body", [
                          _c(
                            "div",
                            { staticClass: "photo-upload-section" },
                            [
                              _vm.isEditing
                                ? _c(
                                    "b-button",
                                    {
                                      staticClass: "mb-3",
                                      attrs: { variant: "outline-secondary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$refs["fileInput"].click()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fi-camera mr-2",
                                      }),
                                      _vm._v(
                                        "\n                  Upload Photo\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.record.unit_image
                                ? _c("div", { staticClass: "current-photo" }, [
                                    _c("img", {
                                      staticClass: "unit-photo",
                                      attrs: {
                                        src: _vm.record.unit_image,
                                        alt: "Unit photo",
                                      },
                                    }),
                                  ])
                                : _c(
                                    "div",
                                    {
                                      staticClass: "no-photo text-center py-3",
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "text-muted mb-0" },
                                        [
                                          _c("i", {
                                            staticClass: "fi-camera mr-2",
                                          }),
                                          _vm._v(
                                            " No photo uploaded\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.record.id
                      ? _c(
                          "b-card",
                          {
                            ref: "tags",
                            staticClass: "section-card",
                            attrs: { "no-body": "", id: "tags" },
                          },
                          [
                            _c(
                              "b-card-header",
                              {
                                staticClass: "p-2 border-bottom-0 text-left",
                                attrs: { "header-tag": "header", role: "tab" },
                              },
                              [
                                _c("i", { staticClass: "fi-price-tag mr-2" }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("unit_modal.tags_title") || "Tags"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("b-card-body", [
                              !_vm.isEditing && _vm.selectedTags.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "tags-display" },
                                    _vm._l(_vm.selectedTags, function (tag) {
                                      return _c(
                                        "div",
                                        {
                                          key: tag.id,
                                          staticClass: "tag-card",
                                          class: {
                                            "tag-card-readonly": !_vm.isEditing,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "tag-content" },
                                            [
                                              _c("i", {
                                                staticClass: "fi-tag tag-icon",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "tag-name" },
                                                [_vm._v(_vm._s(tag.name))]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.isEditing
                                            ? _c(
                                                "button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "b-tooltip",
                                                      rawName:
                                                        "v-b-tooltip.hover.top",
                                                      value: "Remove tag",
                                                      expression:
                                                        "'Remove tag'",
                                                      modifiers: {
                                                        hover: true,
                                                        top: true,
                                                      },
                                                    },
                                                  ],
                                                  staticClass: "tag-remove-btn",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onRemoveTag(
                                                        tag
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fi-x",
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                : !_vm.isEditing
                                ? _c(
                                    "div",
                                    { staticClass: "text-center py-3" },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "text-muted mb-0" },
                                        [
                                          _c("i", {
                                            staticClass: "fi-tag mr-2",
                                          }),
                                          _vm._v(
                                            " No tags assigned\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isEditing
                                ? _c(
                                    "div",
                                    [
                                      _c("Taggregator", {
                                        ref: "tagsTaggregator",
                                        attrs: {
                                          label: "Unit Tags",
                                          labelKey: "name",
                                          name: "tags",
                                          items: _vm.tags,
                                          selections: _vm.selectedTags,
                                          minimum: 0,
                                          quickAddCallback: _vm.onQuickAddTag,
                                          quickAddMinWordCount: 1,
                                          quickAddMinWordLength: 1,
                                          quickAddDescription:
                                            "Please provide valid item name",
                                          quickAddHasUniqueName: true,
                                          onAdd: _vm.onAddTag,
                                          onRemove: _vm.onRemoveTag,
                                        },
                                        on: {
                                          "update:selections": function (
                                            $event
                                          ) {
                                            _vm.selectedTags = $event
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "result",
                                              fn: function ({ result }) {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "result-label",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(result.name) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: "selection",
                                              fn: function ({ selection }) {
                                                return [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(selection.name) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2285527039
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("image-upload-modal", { ref: "upload-modal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }